<template>
  <v-container grid-list-xl>
    <v-layout row wrap>
      <v-flex xs6>
        <h1>Document Types</h1>
      </v-flex>
      <v-flex xs6 class="text-right">
        <v-btn color="accent" outlined dark :to="'/management/document-types/archived'">Archived</v-btn>
        <v-btn color="accent ml-2" depressed dark @click="createDocumentTypeDialog = true">Add Document Type</v-btn>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex xs12>
        <v-card>
          <v-data-table :headers="headers"
                        :items="documentTypes"
                        item-key="id"
                        class="elevation-1">
            <template v-slot:item.action="{ item }">
              <v-icon class="mr-2"
                      color="accent"
                      @click="updateDialogForDocumentType(item)">
                mdi-square-edit-outline
              </v-icon>
              <v-icon color="accent"
                      @click="archiveDialogForDocumentType(item)">
                mdi-archive
              </v-icon>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>
    <add-document-type :showDialog="createDocumentTypeDialog"
                       :toggle="toggleCreate">
    </add-document-type>
    <update-document-type :showDialog="updateDocumentTypeDialog"
                          :toggle="toggleUpdate"
                          :documentTypeDetails="documentTypeToUpdate">
    </update-document-type>
    <archive-document-type :showDialog="archiveDocumentTypeDialog"
                           :toggle="toggleArchive"
                           :documentType="documentTypeArchive">
    </archive-document-type>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import AddDocumentType from '@/components/documentTypes/Add'
import UpdateDocumentType from '@/components/documentTypes/Update'
import ArchiveDocumentType from '@/components/documentTypes/Archive'
export default {
  name: 'listDocumentTypes',
  components: {
    AddDocumentType,
    UpdateDocumentType,
    ArchiveDocumentType
  },
  created () {
    this.loadAllDocumentTypes()
    this.archivedDocTypes() // when adding or updating doc types need to check archived list to prevent duplication
  },
  data () {
    return {
      archiveDocumentTypeDialog: false,
      updateDocumentTypeDialog: false,
      createDocumentTypeDialog: false,
      index: null,
      documentTypeArchive: {},
      documentTypeToUpdate: {}
    }
  },
  methods: {
    ...mapActions({
      loadAllDocumentTypes: 'documentType/loadAllDocumentTypes',
      archivedDocTypes: 'documentType/loadArchives'
    }),
    toggleCreate () {
      this.createDocumentTypeDialog = !(this.createDocumentTypeDialog)
    },
    toggleUpdate () {
      this.updateDocumentTypeDialog = !(this.updateDocumentTypeDialog)
    },
    toggleArchive () {
      this.archiveDocumentTypeDialog = !(this.archiveDocumentTypeDialog)
    },
    archiveDialogForDocumentType (item) {
      this.documentTypeArchive = item
      this.toggleArchive()
    },
    updateDialogForDocumentType (item) {
      this.documentTypeToUpdate = item
      this.toggleUpdate()
    }
  },
  computed: {
    ...mapGetters({
      documentTypes: 'documentType/types',
      headers: 'documentType/headers',
      error: 'documentType/selectError'
    })
  }
}
</script>
